import React from 'react';
import FormLinksList from '@/forms/components/FormLinksList';
import selectors from '../hooks/selectors';
import events from '../hooks/events';

const CatalogueLinksList = ({
  category,
  className,
  code,
  field,
  text = [],
}) => {
  const { canEdit, template } = selectors.useCatalogueLinksList({ category, code });
  const addItem = events.useAddCatalogueLink(category, { code });
  const showItem = events.useShowCatalogueLinks(category, { code });

  return (
    <FormLinksList
      addItem={() => addItem({ activeFieldName: field.name, template })}
      canEdit={canEdit}
      className={className}
      code={code}
      entity="catalogue.link"
      field={field}
      showItem={(index) => showItem({ activeFieldName: field.name, activeIndex: index, template })}
      text={Array.isArray(text) ? text : []}
    />
  );
};

export default CatalogueLinksList;
